const PROJECT_ANALYTICS = {
	PROJECT: 'project:analytics:project',
	PRICE: 'project:analytics:price',
	ORDER: 'project:analytics:order',
	MATERIAL: 'project:analytics:material',
	WORK: 'project:analytics:work',
	WORKER: 'project:analytics:worker',
};
const PROJECT_CERTIFICATES = {
	READ: 'project:certificates:read',
	MANAGE: 'project:certificates:manage',
};
const PROJECT_CONTRACTOR = {
	LIST: 'project:contractor:list',
	READ: 'project:contractor:read',
	ACCESS: 'project:contractor:access',
	DELETE: 'project:contractor:delete',
};
const PROJECT_DELIVERY = {
	READ: 'project:delivery:read',
	DOC: 'project:delivery:doc',
	CREATE: 'project:delivery:create',
	DELETE: 'project:delivery:delete',
};
const PROJECT_INPUT_CONTROL = {
	READ: 'project:input-control:read',
	UPDATE: 'project:input-control:update',
};
const PROJECT_ESTIMATE = {
	READ: 'project:estimate:read',
	UPDATE: 'project:estimate:update',
};
const PROJECT_FROM_KS = {
	READ: 'project:form-ks:read',
	CREATE: 'project:form-ks:create',
	UPDATE: 'project:form-ks:update',
	DELETE: 'project:form-ks:delete',
};
const PROJECT_GRANT = {
	READ: 'project:gant:read',
	CREATE: 'project:gant:create',
	UPDATE: 'project:gant:update',
	DELETE: 'project:gant:delete',
};
const PROJECT_CALENDAR = {
	READ: 'project:calendar:read',
	UPDATE: 'project:calendar:update',
};
const PROJECT_JOURNAL = {
	READ: 'project:journal:read',
	CREATE: 'project:journal:create',
	UPDATE: 'project:journal:update',
	DELETE: 'project:journal:delete',
	CREATE_RECORDS: 'project:journal-records:create',
	UPDATE_RECORDS: 'project:journal-records:update',
	DELETE_RECORDS: 'project:journal-records:delete',
};
const PROJECT_CALENDAR_MACHINE = {
	READ: 'project:calendar-machine:read',
	CREATE: 'project:calendar-machine:create',
	UPDATE: 'project:calendar-machine:update',
	DELETE: 'project:calendar-machine:delete',
};
const PROJECT_MATERIAL = {
	READ: 'project:material:read',
	CREATE: 'project:material:create',
	UPDATE: 'project:material:update',
	DELETE: 'project:material:delete',
};
const PROJECT_ORDER = {
	READ_FEED: 'project:order_feed:read',
	UPDATE_FEED: 'project:order_feed:read',
	PRODUCTION: 'project:order_production:read',
};
const PROJECT_OUTFIT = {
	PLAN_READ: 'project:outfit:plan:read',
	PLAN_CREATE: 'project:outfit:plan:create',
	PLAN_UPDATE: 'project:outfit:plan:update',
	PLAN_DELETE: 'project:outfit:plan:delete',
	FACT_READ: 'project:outfit:fact:read',
	FACT_CREATE: 'project:outfit:fact:create',
	FACT_DELETE: 'project:outfit:fact:delete',
};
const PROJECT_ROOT = {
	CREATE: 'project:root:create',
	UPDATE: 'project:root:update',
	DELETE: 'project:root:delete',
	COPY: 'project:root:copy',
	LIST: 'project:root:list',
	USER_READ: 'project:root:user:read',
	USER_ADD: 'project:root:user:add',
};
const PROJECT_REMARK = {
	READ: 'project:remark:read',
	CREATE: 'project:remark:create',
	UPDATE: 'project:remark:update',
	DELETE: 'project:remark:delete',
	UPDATE_STATUS: 'project:remark:update_status',
	MSG: 'project:remark:msg',
	FILES: 'project:remark:files',
	INSP: 'project:remark:insp',
};
const PROJECT_STORAGE = {
	READ: 'project:storage:read',
	UPDATE: 'project:storage:update',
	MOVE_READ: 'project:storage:move:read',
	MOVE_CREATE: 'project:storage:move:create',
	MOVE_UPDATE: 'project:storage:move:update',
	MOVE_DELETE: 'project:storage:move:delete',
};
const PROJECT_TEAM = {
	READ: 'project:team:read',
	MANAGE: 'project:team:manage',
};
const PROJECT_TOOL_UW = {
	USE_READ: 'project:tool_use:read',
	USE_MANAGE: 'project:tool_use:manage',
	WRITE_READ: 'project:tool_write:read',
	WRITE_MANAGE: 'project:tool_write:manage',
};
const PROJECT_WAYBILL = {
	READ: 'project:waybill:read',
	MANAGE: 'project:waybill:manage',
};
const PROJECT_WELDING = {
	READ: 'project:welding:read',
	MANAGE: 'project:welding:manage',
	MANAGE_RECORDS: 'project:welding-records:manage',
};
const PROJECT_WORK = {
	READ: 'project:work:read',
	MANAGE: 'project:work:manage',
	MANAGE_RESOURCE: 'project:work_resource:manage',
};
const PROJECT_WORKER = {
	READ: 'project:worker:read',
	MANAGE: 'project:worker:manage',
};
const PROJECT_ESTIMATE_LOAD = {
	GRAND_FILE: 'project:estimate_load:grand_file',
	EXCEL_FILE: 'project:estimate_load:excel_file',
};
const PROJECT_SHIPMENT = {
	MATERIAL: {
		READ: 'project:shipment:material:read',
		MANAGE: 'project:shipment:material:manage'
	},
	RENT: {
		READ: 'project:shipment:rent:read',
		MANAGE: 'project:shipment:rent:manage'
	},
	RECEIPT: {
		READ: 'project:shipment:receipt:read',
		MANAGE: 'project:shipment:receipt:manage'
	},
	EQUIPMENT: {
		READ: 'project:shipment:equipment:read',
		MANAGE: 'project:shipment:equipment:manage'
	},
};
const PROJECT = {
	ARCHIVE: 'project:archive',
	ANALYTICS: PROJECT_ANALYTICS,
	CERTIFICATES: PROJECT_CERTIFICATES,
	CONTRACTOR: PROJECT_CONTRACTOR,
	DELIVERY: PROJECT_DELIVERY,
	INPUT_CONTROL: PROJECT_INPUT_CONTROL,
	ESTIMATE: PROJECT_ESTIMATE,
	ESTIMATE_LOAD: PROJECT_ESTIMATE_LOAD,
	FROM_KS: PROJECT_FROM_KS,
	GRANT: PROJECT_GRANT,
	CALENDAR: PROJECT_CALENDAR,
	JOURNAL: PROJECT_JOURNAL,
	CALENDAR_MACHINE: PROJECT_CALENDAR_MACHINE,
	MATERIAL: PROJECT_MATERIAL,
	OCR_ENTERA: 'project:ocr_entera',
	ORDER: PROJECT_ORDER,
	OUTFIT: PROJECT_OUTFIT,
	ROOT: PROJECT_ROOT,
	REMARK: PROJECT_REMARK,
	STORAGE: PROJECT_STORAGE,
	TEAM: PROJECT_TEAM,
	TOOL_UW: PROJECT_TOOL_UW,
	WAYBILL: PROJECT_WAYBILL,
	WELDING: PROJECT_WELDING,
	WORK: PROJECT_WORK,
	WORKER: PROJECT_WORKER,
	SHIPMENT: PROJECT_SHIPMENT,
};
const DOC = {
	REMOVAL_P: {
		READ: 'doc:removal_p:read',
		MANAGE: 'doc:removal_p:manage',
	},
	REMOVAL_P_EQUIPMENT: {
		READ: 'doc:removal_p_equipment:read',
		MANAGE: 'doc:removal_p_equipment:manage',
	},
	AOC: {
		READ: 'doc:aoc:read',
		MANAGE: 'doc:aoc:manage',
	},
	CAR_RENTAL: {
		READ: 'doc:car_rental:read',
		MANAGE: 'doc:car_rental:manage',
	},
	MAT_ORDER_P: {
		READ: 'doc:mat_order_p:read',
		MANAGE: 'doc:mat_order_p:manage',
	},
	INSP_HID_W: {
		READ: 'doc:insp_hid_w:read',
		MANAGE: 'doc:insp_hid_w:manage'
	},
};
const CATALOG = {
	EQUIPMENT: {
		READ: 'catalog:equipment:read',
		MANAGE: 'catalog:equipment:manage'
	},
	PROVIDER: {
		READ: 'catalog:provider:read',
		MANAGE: 'catalog:provider:manage'
	},
	WORKER: {
		READ: 'catalog:worker:read',
		MANAGE: 'catalog:worker:manage'
	},
	READ: 'catalog:read',
	CREATE: 'catalog:create',
	UPDATE: 'catalog:update',
	DELETE: 'catalog:delete',
	TEMPLATE: {
		READ: 'catalog:template:read',
		MANAGE: 'catalog:template:manage'
	},
};
const FACILITY = {
	READ_ALL: 'facility:read_all',
	CREATE: 'facility:create',
	DELETE: 'facility:delete',
	UPDATE: 'facility:update',
	ACCESS: {
		READ: 'facility:access:read',
		MANAGE: 'facility:access:manage',
	},
	FORM_KS3: {
		READ: 'facility:form_ks3:read',
		MANAGE: 'facility:form_ks3:manage',
	},
	RESP_PERSON: {
		READ: 'facility:resp_person:read',
		MANAGE: 'facility:resp_person:manage',
	},
	FILES: {
		READ: 'facility:files:read',
		MANAGE: 'facility:files:manage',
	},
	MACHINE: {
		READ: 'facility:machine:read',
		MANAGE: 'facility:machine:manage',
	},
};
const STORAGE_MAIN = {
	INVENTORY: {
		READ: 'storage:inventory:read',
		MANAGE: 'storage:inventory:manage',
		MOVE_READ: 'storage:inventory:move_read',
		MOVE_MANAGE: 'storage:inventory:move_manage',
	},
	READ: 'storage:read',
	MANAGE: 'storage:manage',
	MATERIAL: {
		ADD_READ: 'storage:material:add_read',
		ADD_MANAGE: 'storage:material:add_manage',
		MOVE_READ: 'storage:material:move_read',
		MOVE_MANAGE: 'storage:material:move_manage',
	}
};
const SHARE = {
	MANAGE: 'share:manage'
};
const TENDER = {
	ALL: 'tender:all',
};
const WORK_DOC = {
	READ: 'catalog:equipment:read',
	MANAGE: 'catalog:equipment:manage'
};
const USER = {
	READ: 'user:read',
	CREATE: 'user:create',
	UPDATE: 'user:update',
	DELETE: 'user:delete',
	ENTERA_MANAGE: 'user:entera_manage',
};

const SLUGS = {
	PROJECT,
	DOC,
	CATALOG,
	FACILITY,
	STORAGE: STORAGE_MAIN,
	SHARE,
	TENDER,
	OCR: 'ocr:all',
	WORK_DOC,
	USER,
	ROLES: 'roles:all'
};
module.exports = { SLUGS: SLUGS, };
